import React, { useState, useEffect } from "react";
import { Heading } from "../../components/style/Heading";
import { TitleButtons } from "../../components/style/TitleButtons";
import { ColorPicker } from "../../components/style/ColorPicker";

export const Materials = ({
  isActive,
  onComplete,
  items,
  manager,
  setOverrideStep,
}) => {
  const { state } = manager;

  return (
    <>
      <Heading
        isActive={isActive}
        completed={state.completedLegMaterials}
        completedAttr={"completedLegMaterials"}
        setState={manager.setState}
        title="Materijal"
        onClick={() => setOverrideStep(0)}
      />
      <div className="styling-wrap__contents | js-conf-styling-wrap-content">
        {!state.completedLegMaterials && isActive && (
          <>
            <TitleButtons
              title="Izaberite materijal nogu"
              items={items}
              activeItem={state.legMaterial}
              setActiveItem={(item) => manager.selectMaterial(item)}
              handleComplete={() => {
                manager.setState((prev) => ({
                  ...prev,
                  completedLegMaterials: true,
                }));
                onComplete();
              }}
            />

            {state.legMaterial?.has_colors && (
              <>
                {state.legMaterial.sample_option ? (
                  <TitleButtons
                    title="Boja"
                    sample
                    items={[
                      {
                        name: state.legMaterial.color_category,
                        next_step: false,
                      },
                      { name: "Donosim uzorak u salon", next_step: true },
                    ]}
                    activeItem={state.legColor}
                    setActiveItem={(item) => manager.selectColor(item)}
                    handleComplete={() => {
                      manager.setState((prev) => ({
                        ...prev,
                        completedLegMaterials: true,
                      }));
                      onComplete();
                    }}
                  />
                ) : (
                  <ColorPicker
                    title={state.legMaterial.color_category}
                    colors={state.legMaterial.colors}
                    onComplete={() => {
                      manager.setState((prev) => ({
                        ...prev,
                        completedLegMaterials: true,
                      }));
                      onComplete();
                    }}
                    handleColorClick={(item) => manager.selectColor(item)}
                  />
                )}
              </>
            )}

            {state.legMaterial &&
              state.legColor &&
              state.legColor.name === state.legMaterial.color_category && (
                <ColorPicker
                  title={state.legMaterial.color_category}
                  colors={state.legMaterial.colors}
                  onComplete={() => {
                    manager.setState((prev) => ({
                      ...prev,
                      completedLegMaterials: true,
                    }));
                    onComplete();
                  }}
                  handleColorClick={(item) => {
                    manager.selectColorCategory(item);
                  }}
                />
              )}
          </>
        )}
      </div>
    </>
  );
};
